import ApiLoader from './ApiLoader'


export default class YoutubeLoader extends ApiLoader {
  constructor() {
    super('https://www.youtube.com/iframe_api', 'YT')
    this._re = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/
    // Oh we are so clever in google, aren't we?
    // the only way to know when player is ready
    // is to sit and wait for it inside onYouTubeIframeAPIReady function
    window.onYouTubeIframeAPIReady = this._onScriptLoad.bind(this)
  }

  getApiObject() {
    return window.YT
  }

  load() {
    if (this._loading || this.isReady()) return

    this._loading = true

    let tag = document.createElement('script')
    tag.setAttribute('async', 'true')
    tag.setAttribute('defer', 'true')
    tag.src = this.src
    document.head.appendChild(tag)
  }

  parseVideoID(url) {
    let matches = url.match(this._re)
    return matches ? matches[1] : false
  }
}
